const title = "Audit log";

const entryDialog = {
	title: "Audit log entry",
};
const table = {
	export: { csv: "CSV Exporteren" },
	headers: {
		created_at: "Aangemaakt op",
		debtor_code: "Debiteur code",
		entry: "Entry",
		event: "Event",
		ip_address: "IP-adres",
		username: "Username",
	},
};

const audit_log = {
	entry_dialog: entryDialog,
	table: table,
	title: title,
};

export default audit_log;
